export default "__VITE_ASSET__DZYGk9BL__"